import { handleActions } from 'redux-actions';
import { chatFlowActions } from '../actions/chatFlow';
import { chatFlowsGetAll } from './chatFlows';
export const { chatFlowAdd, chatFlowAddActionClicked, chatFlowAddAfterChatWidgetCreated, chatFlowAddFailed, chatFlowAddSucceeded, chatFlowClearState, chatFlowEdit, chatFlowEditFailed, chatFlowEditSucceeded, chatFlowGet, chatFlowGetFailed, chatFlowGetSucceeded, } = chatFlowActions;
// Init state for the Chat Flow.
const initialState = {
    id: null,
    meta: {
        asyncStatus: 'succeeded',
        hasUnSavedChanges: false,
    },
    name: '',
    widget_id: null,
};
// Reducer
const chatFlow = handleActions({
    [chatFlowsGetAll.toString()]: () => {
        return initialState;
    },
    [chatFlowAdd.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [chatFlowAddSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }) });
    },
    [chatFlowAddFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [chatFlowAddAfterChatWidgetCreated.toString()]: (state) => {
        return Object.assign({}, state);
    },
    [chatFlowEdit.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [chatFlowEditSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }) });
    },
    [chatFlowEditFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [chatFlowGet.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [chatFlowGetSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), id: action.payload.data.id, name: action.payload.data.name, widget_id: action.payload.data.location, isActive: action.payload.data.active });
    },
    ['CHAT_UPDATE_WIDGET_SUCCEEDED']: (state, action) => {
        return Object.assign(Object.assign({}, state), { name: action.widget.updates.name });
    },
    [chatFlowGetFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [chatFlowClearState.toString()]: (state) => {
        return initialState;
    },
}, initialState);
export default chatFlow;
